<template>
  <div class="client-details">
    <portal to="sidebar-menu">
      <div>
        <nav-back-button to="/talent/candidates">
          {{$t('candidates.details.menu.back')}}
        </nav-back-button>
        <div class="flex items-center pb-3 my-2 border-b border-gray-200">
          <div class="flex-shrink-0">
            <base-avatar :src="get(candidate, 'user.image')"
                         :name="candidate.given_name"/>
          </div>
          <div class="ml-4">
            <h3 class="text-lg leading-6 font-medium text-gray-900 truncate w-40">
              {{candidate.given_name}} {{candidate.family_name}}
            </h3>
            <p class="text-sm leading-5 text-gray-500">
              <span>
                {{candidate.email}}
              </span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <nav-list :items="navigationItems"
                      @on-delete-click="deleteCandidate">
            </nav-list>
          </div>
        </div>
      </div>

    </portal>
    <router-view></router-view>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import candidateModule from 'src/store/modules/candidate'
  import { entities, getRouteName, routeTypes } from 'src/config/routeTypes'
  import NavList from 'src/components/List/NavList'
  import CandidateService from 'src/services/CandidateService'
  import { mapMutations } from 'vuex'

  export default {
    name: 'candidate-details',
    components: {
      NavList
    },
    data () {
      return {
        error: null,
        deleteActive: false
      }
    },
    computed: {
      candidate () {
        return this.$store.state.candidate.currentCandidate || {}
      },
      navigationItems () {
        return [
          {
            name: this.$t('generic.general'),
            type: 'group'
          },
          {
            routeName: 'candidate_dashboard',
            name: this.$t('candidates.details.dashboard')
          },
          {
            routeName: 'candidate_edit',
            name: this.$t('generic.edit')
          },
          {
            routeName: 'candidate_applicants',
            name: this.$t('generic.applicants')
          },
          {
            routeName: 'candidate_job-alerts',
            name: this.$t('generic.jobAlerts')
          },
          {
            routeName: 'candidate_resumes',
            name: this.$t('generic.resumes')
          },
          {
            name: this.$t('generic.delete.title')
          },
        ]
      }
    },
    methods: {
      get,
      ...mapMutations('candidate', [candidateModule.types.SET_CURRENT_CANDIDATE]),
      async deleteCandidate () {
        let id = this.$route.params.id
        await this.$confirm(this.$t('generic.delete.confirm', {title: id, entity: entities.CANDIDATE}), {
          dangerouslyUseHTMLString: true
        })
        await CandidateService.delete(id)
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.CANDIDATE)})
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await CandidateService.getById(id, {
          with: 'user,favourites,user,job_alerts,resumes'
        })
        let candidate = res.data
        if (candidate) {
          next(vm => {
            console.log(candidateModule)
            vm[candidateModule.types.SET_CURRENT_CANDIDATE](candidate)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
<style lang="scss">
</style>
